var React = require('react');

function LinkInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.8313 15.5025L8.64814 17.6857C6.89602 19.4378 4.05925 19.4378 2.31409 17.6857C0.56197 15.9336 0.56197 13.0968 2.31409 11.3517L4.49728 9.16846","stroke":"#300D4F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M9.16891 4.49728L11.3521 2.31409C13.1042 0.56197 15.941 0.56197 17.6862 2.31409C19.4383 4.06621 19.4383 6.90297 17.6862 8.64814L15.503 10.8313","stroke":"#300D4F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M7.2177 12.781L12.78 7.21875","stroke":"#300D4F","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

LinkInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = LinkInline;

LinkInline.default = LinkInline;
